import { all, call, fork, takeLatest } from 'redux-saga/effects';

import { watchMeetingsFormSaga } from '../../meetings/meeting-form/meeting-form.saga-watchers';
import * as constants from './meetings.constants';
import * as types from './meetings.types';

import * as services from './meetings.saga-services';

function* invokeFinishMeetingSession(action: types.IFinishMeetingSession) {
  yield call(services.finishMeetingSession, action.payload.meetingId);
}

export function* watchMeetingsPurePageSaga() {
  // yield takeLatest(constants.FETCH_MEETINGS, invokeSetupMeetings);
  // yield takeLatest(constants.CREATE_MEETING, invokeCreateMeeting);
  // yield takeLatest(constants.UPDATE_MEETING, invokeUpdateMeeting);
  // yield takeLatest(constants.DELETE_MEETING, invokeDeleteMeeting);
  // yield takeLatest(constants.START_MEETING_SESSION, invokeStartMeetingSession);
  yield takeLatest(constants.FINISH_MEETING_SESSION_SOCKET, invokeFinishMeetingSession);
  // yield takeLatest(constants.JOIN_MEETING, invokeJoinMeeting);
  // yield takeEvery(constants.SAVE_MEETING_SOCKET, invokeSaveMeetingSocket);
  // yield takeEvery(constants.START_MEETING_SESSION_SOCKET, invokeStartMeetingSessionSocket);
  // yield takeEvery(constants.JOIN_MEETING_SOCKET, invokeJoinMeetingSocket);
}

export function* watchMeetingsPageSaga() {
  yield all([watchMeetingsPurePageSaga, watchMeetingsFormSaga].map(fork));
}
